<template>
  <div class="container col-md-12">
    <h1>Output fields</h1>
    <roe-calc-input-fields
      :inputCategories="inputCategories"
      :calcAction="calcAction"
    >
    </roe-calc-input-fields>

    <div v-if="calcData">
      <hr />
      <h3>Result</h3>
      <md-content>
        <md-content class="md-padding">
          <table class="table table-striped table-bordered">
            <tr>
              <th>Fields</th>
              <th>Data</th>
            </tr>
            <tr>
              <td
                colspan="4"
                scope="colgroup"
                style="background-color: black; color:white"
              >
                Basic Plan Information
              </td>
            </tr>
            <tr>
              <td>ein_plan_code</td>
              <td>{{ calcData.plan_basic_data.ein_plan_code }}</td>
            </tr>
            <tr>
              <td>plan_number_three_digit</td>
              <td>{{ calcData.plan_basic_data.plan_number }}</td>
            </tr>
            <tr>
              <td>Data as of Date</td>
              <td>{{ calcData.plan_basic_data.date | date("MM/D/YYYY") }}</td>
            </tr>
            <tr>
              <td>Data as of Date in Months</td>
              <td>{{ calcData.plan_basic_data_date_in_month }}</td>
            </tr>
            <tr>
              <td
                colspan="4"
                scope="colgroup"
                style="background-color: black; color:white"
              >
                Plan Design Fields: Employee Contributions
              </td>
            </tr>
            <tr>
              <td>Age requirement EE contributions - Yrs</td>
              <td>{{ calcData.employee_contribution.req_age_years }}</td>
            </tr>
            <tr>
              <td>Age requirement EE Contributions - Mos</td>
              <td>{{ calcData.employee_contribution.req_age_months }}</td>
            </tr>
            <tr>
              <td>Service requirement EE contributions - Months</td>
              <td>{{ calcData.employee_contribution.req_service_months }}</td>
            </tr>
            <tr>
              <td>Entry date</td>
              <td>{{ calcData.employee_contribution.entry_date_type }}</td>
            </tr>
            <tr>
              <td>Excluded Employees</td>
              <td>{{ calcData.employee_contribution.excluded_employees }}</td>
            </tr>
            <tr>
              <td>Contribution Pre-Tax</td>
              <td>{{ calcData.employee_contribution.pre_tax }}</td>
            </tr>
            <tr>
              <td>Contribution Pre-Tax Maximum</td>
              <td>{{ calcData.employee_contribution.pre_tax_max }}%</td>
            </tr>
            <tr>
              <td>Contribution Roth</td>
              <td>{{ calcData.employee_contribution.roth }}</td>
            </tr>
            <tr>
              <td>Contribution Roth Maximum</td>
              <td>
                {{ calcData.employee_contribution.roth_max | numeral("0.0") }}%
              </td>
            </tr>
            <tr>
              <td>Contribution Post-Tax</td>
              <td>{{ calcData.employee_contribution.post_tax }}</td>
            </tr>
            <tr>
              <td>Contribution Post-Tax Maximum</td>
              <td>
                {{
                  calcData.employee_contribution.post_tax_max | numeral("0.0")
                }}%
              </td>
            </tr>
            <tr>
              <td>Contribution Combined</td>
              <td>{{ calcData.employee_contribution.combined }}</td>
            </tr>
            <tr>
              <td>Contribution Combined Maximum</td>
              <td>
                {{
                  calcData.employee_contribution.combined_max | numeral("0.0")
                }}%
              </td>
            </tr>
            <tr>
              <td>Catch-up</td>
              <td>{{ calcData.employee_contribution.catch_up }}</td>
            </tr>
            <tr>
              <td
                colspan="4"
                scope="colgroup"
                style="background-color: black; color:white"
              >
                Plan Design Fields: Auto Enroll & Auto Escalate
              </td>
            </tr>
            <tr>
              <td>Plan Auto-Enrollment</td>
              <td>{{ calcData.auto_enrollment.plan }}</td>
            </tr>
            <tr>
              <td>Plan Auto-Enrollment Initial Percentage</td>
              <td>
                {{ calcData.auto_enrollment.initial_percent | numeral("0.0") }}%
              </td>
            </tr>
            <tr>
              <td>Plan Auto Enrollment Type</td>
              <td>{{ calcData.auto_enrollment.type }}</td>
            </tr>
            <tr>
              <td>Plan Auto Increase Type</td>
              <td>{{ calcData.auto_increase.type }}</td>
            </tr>
            <tr>
              <td>Plan Auto Increase Source</td>
              <td>{{ calcData.auto_increase.source }}</td>
            </tr>
            <tr>
              <td>Plan Auto Increase Annual</td>
              <td>{{ calcData.auto_increase.annual | numeral("0.0") }}%</td>
            </tr>
            <tr>
              <td>Plan Auto Increase Max</td>
              <td>{{ calcData.auto_increase.max | numeral("0.0") }}%</td>
            </tr>
            <tr>
              <td>Plan Auto Increase Date</td>
              <td>{{ calcData.auto_increase.date_type }}</td>
            </tr>
            <tr>
              <td
                colspan="4"
                scope="colgroup"
                style="background-color: black; color:white"
              >
                Plan Design Fields: Employer Match
              </td>
            </tr>
            <tr>
              <td>ER Match</td>
              <td>{{ calcData.employer_match.er_match }}</td>
            </tr>
            <tr>
              <td>ER Match Age requirement Years</td>
              <td>{{ calcData.employer_match.req_age_years }}</td>
            </tr>
            <tr>
              <td>ER Match Age requirement Months</td>
              <td>{{ calcData.employer_match.req_age_months }}</td>
            </tr>
            <tr>
              <td>ER Match Service requirement Years</td>
              <td>{{ calcData.employer_match.req_service_years }}</td>
            </tr>
            <tr>
              <td>ER Match Service requirement Months</td>
              <td>{{ calcData.employer_match.req_service_months }}</td>
            </tr>
            <tr>
              <td>ER Matching Type</td>
              <td>{{ calcData.employer_match.type }}</td>
            </tr>
            <tr>
              <td>ER Match Vary on YOS</td>
              <td>{{ calcData.employer_match.yos_vary }}</td>
            </tr>
            <tr>
              <td>ER Match Number of Tiers</td>
              <td>{{ calcData.employer_match.tiers.length }}</td>
            </tr>
            <tr>
              <td>ER Match Tier 1 Matching Amount</td>
              <td>
                {{
                  calcData.employer_match.tiers[0].matching_amount
                    | numeral("0.0")
                }}%
              </td>
            </tr>
            <tr>
              <td>ER Match Tier 1 Deferral Rate</td>
              <td>
                {{
                  calcData.employer_match.tiers[0].deferral_rate
                    | numeral("0.0")
                }}%
              </td>
            </tr>
            <tr>
              <td>ER Match Tier 1 Contribution Amount</td>
              <td>
                {{
                  calcData.employer_match.tiers[0].contribution_amount
                    | currency
                }}
              </td>
            </tr>
            <tr>
              <td>ER Match Tier 1 YOS Upper Limit</td>
              <td>{{ calcData.employer_match.tiers[0].yos_upper_limit }}</td>
            </tr>
            <tr>
              <td>ER Match Tier 2 Matching Amount</td>
              <td>
                {{
                  calcData.employer_match.tiers[1].matching_amount
                    | numeral("0.0")
                }}%
              </td>
            </tr>
            <tr>
              <td>ER Match Tier 2 Deferral Rate</td>
              <td>
                {{
                  calcData.employer_match.tiers[1].deferral_rate
                    | numeral("0.0")
                }}%
              </td>
            </tr>
            <tr>
              <td>ER Match Tier 2 Contribution Amount</td>
              <td>
                {{
                  calcData.employer_match.tiers[1].contribution_amount
                    | currency
                }}
              </td>
            </tr>
            <tr>
              <td>ER Match Tier 2 YOS Upper Limit</td>
              <td>{{ calcData.employer_match.tiers[1].yos_upper_limit }}</td>
            </tr>
            <tr>
              <td>ER Match Tier 3 Matching Amount</td>
              <td>
                {{
                  calcData.employer_match.tiers[2].matching_amount
                    | numeral("0.0")
                }}%
              </td>
            </tr>
            <tr>
              <td>ER Match Tier 3 Deferral Rate</td>
              <td>
                {{
                  calcData.employer_match.tiers[2].deferral_rate
                    | numeral("0.0")
                }}%
              </td>
            </tr>
            <tr>
              <td>ER Match Tier 3 Contribution Amount</td>
              <td>
                {{
                  calcData.employer_match.tiers[2].contribution_amount
                    | currency
                }}
              </td>
            </tr>
            <tr>
              <td>ER Match Tier 3 YOS Upper Limit</td>
              <td>{{ calcData.employer_match.tiers[2].yos_upper_limit }}</td>
            </tr>
            <tr>
              <td>ER Match Tier 4 Matching Amount</td>
              <td>
                {{
                  calcData.employer_match.tiers[3].matching_amount
                    | numeral("0.0")
                }}%
              </td>
            </tr>
            <tr>
              <td>ER Match Tier 4 Deferral Rate</td>
              <td>
                {{
                  calcData.employer_match.tiers[3].deferral_rate
                    | numeral("0.0")
                }}%
              </td>
            </tr>
            <tr>
              <td>ER Match Tier 4 Contribution Amount</td>
              <td>
                {{
                  calcData.employer_match.tiers[3].contribution_amount
                    | currency
                }}
              </td>
            </tr>
            <tr>
              <td>ER Match Tier 4 YOS Upper Limit</td>
              <td>{{ calcData.employer_match.tiers[3].yos_upper_limit }}</td>
            </tr>
            <tr>
              <td>ER Match Tier 5 Matching Amount</td>
              <td>
                {{
                  calcData.employer_match.tiers[4].matching_amount
                    | numeral("0.0")
                }}%
              </td>
            </tr>
            <tr>
              <td>ER Match Tier 5 Deferral Rate</td>
              <td>
                {{
                  calcData.employer_match.tiers[4].deferral_rate
                    | numeral("0.0")
                }}%
              </td>
            </tr>
            <tr>
              <td>ER Match Tier 5 Contribution Amount</td>
              <td>
                {{
                  calcData.employer_match.tiers[4].contribution_amount
                    | currency
                }}
              </td>
            </tr>
            <tr>
              <td>ER Match Tier 5 YOS Upper Limit</td>
              <td>{{ calcData.employer_match.tiers[4].yos_upper_limit }}</td>
            </tr>
            <tr>
              <td>ER Match Dollar Limit</td>
              <td>{{ calcData.employer_match.dollar_limit }}</td>
            </tr>
            <tr>
              <td>ER Match Dollar Limit Amount</td>
              <td>
                {{ calcData.employer_match.dollar_limit_amount | currency }}
              </td>
            </tr>
            <tr>
              <td>ER Match Catch-Up Contribution Matched</td>
              <td>{{ calcData.employer_match.catch_up_matched }}</td>
            </tr>
            <tr>
              <td>ER Match Funding Frequency</td>
              <td>{{ calcData.employer_match.funding_frequency }}</td>
            </tr>
            <tr>
              <td>er_matching_contribution_ytd_dollars</td>
              <td>{{ calcData.employer_other.ytd_dollars | currency }}</td>
            </tr>
            <tr>
              <td
                colspan="4"
                scope="colgroup"
                style="background-color: black; color:white"
              >
                Plan Design Fields: Employer Other
              </td>
            </tr>
            <tr>
              <td>ER Other</td>
              <td>{{ calcData.employer_other.er_other }}</td>
            </tr>
            <tr>
              <td>ER Other Age Requirement Years</td>
              <td>{{ calcData.employer_other.req_age_years }}</td>
            </tr>
            <tr>
              <td>ER Other Age Requirement Months</td>
              <td>{{ calcData.employer_other.req_age_months }}</td>
            </tr>
            <tr>
              <td>ER Other Service Requirement</td>
              <td>{{ calcData.employer_other.req_service_years }}</td>
            </tr>
            <tr>
              <td>ER Other Service Requirement Months</td>
              <td>{{ calcData.employer_other.req_service_months }}</td>
            </tr>
            <tr>
              <td>ER Other Percent of Compensation</td>
              <td>
                {{
                  calcData.employer_other.compensation_percent | numeral("0.0")
                }}%
              </td>
            </tr>
            <tr>
              <td>ER Other Dollar Limit</td>
              <td>{{ calcData.employer_other.dollar_limit }}</td>
            </tr>
            <tr>
              <td>ER Other Dollar Limit Amount</td>
              <td>
                {{ calcData.employer_other.dollar_limit_amount | currency }}
              </td>
            </tr>
            <tr>
              <td>ER Other Flat Dollar Amount</td>
              <td>
                {{ calcData.employer_other.flat_dollar_limit | currency }}
              </td>
            </tr>
            <tr>
              <td>ER Other SSI - % of comp below level</td>
              <td>
                {{
                  calcData.employer_other.compensation_below_lvl
                    | numeral("0.2")
                }}%
              </td>
            </tr>
            <tr>
              <td>ER Other SSI - compensation amount</td>
              <td>
                {{ calcData.employer_other.compensation_amount | currency }}
              </td>
            </tr>
            <tr>
              <td>ER Other SSI - % of comp above level</td>
              <td>
                {{
                  calcData.employer_other.compensation_above_lvl
                    | numeral("0.2")
                }}%
              </td>
            </tr>
            <tr>
              <td>ER Other Funding Frequency</td>
              <td>{{ calcData.employer_other.funding_frequency }}</td>
            </tr>
            <tr>
              <td>er_other_contribution_ytd_dollars</td>
              <td>{{ calcData.employer_other.ytd_dollars | currency }}</td>
            </tr>
            <tr>
              <td
                colspan="4"
                scope="colgroup"
                style="background-color: black; color:white"
              >
                Basic Participant Information
              </td>
            </tr>
            <tr>
              <td>participant_identifier</td>
              <td>{{ calcData.participant.participant_identifier }}</td>
            </tr>
            <tr>
              <td>date_time_stamp</td>
              <!--<td>{{ new Date() }}</td>-->
            </tr>
            <tr>
              <td>desired_retirement_state</td>
              <td>{{ calcData.participant.drd_state }}</td>
            </tr>
            <tr>
              <td>hours_per_week</td>
              <td>{{ calcData.participant.hours_per_week }}</td>
            </tr>
            <tr>
              <td>gender</td>
              <td>{{ calcData.participant.gender }}</td>
            </tr>
            <tr>
              <td>marital_status</td>
              <td>{{ calcData.participant.marital_status }}</td>
            </tr>
            <tr>
              <td
                colspan="4"
                scope="colgroup"
                style="background-color: black; color:white"
              >
                Participant Dates
              </td>
            </tr>
            <tr>
              <td>Date of Birth</td>
              <td>{{ calcData.participant.birth_date | date("MM/D/YYYY") }}</td>
            </tr>
            <tr>
              <td>Date of Hire</td>
              <td>{{ calcData.participant.hire_date | date("MM/D/YYYY") }}</td>
            </tr>
            <tr>
              <td>Date of Termination</td>
              <td>
                {{ calcData.participant.termination_date | date("MM/D/YYYY") }}
              </td>
            </tr>
            <tr>
              <td>Retirement Date: Desired</td>
              <td>{{ calcData.retirement_dates.drd | date("MM/D/YYYY") }}</td>
            </tr>
            <tr>
              <td>Retirement Date: Age 62 per SSA</td>
              <td>
                {{ calcData.retirement_dates.age62_date | date("MM/D/YYYY") }}
              </td>
            </tr>
            <tr>
              <td>Retirement Date: Normal Retirement Date per SSA</td>
              <td>{{ calcData.retirement_dates.nrd | date("MM/D/YYYY") }}</td>
            </tr>
            <tr>
              <td>Retirement Date: Age 70 per SSA</td>
              <td>
                {{ calcData.retirement_dates.age70_date | date("MM/D/YYYY") }}
              </td>
            </tr>
            <tr>
              <td>Eligibility Date: EE Contribs</td>
              <td>{{ calcData.adjust_entry_dates.ee | date("MM/D/YYYY") }}</td>
            </tr>
            <tr>
              <td>Eligibility Date: ER Match</td>
              <td>
                {{ calcData.adjust_entry_dates.er_match | date("MM/D/YYYY") }}
              </td>
            </tr>
            <tr>
              <td>Eligibility Date: ER Other</td>
              <td>
                {{ calcData.adjust_entry_dates.er_other | date("MM/D/YYYY") }}
              </td>
            </tr>
            <tr>
              <td
                colspan="4"
                scope="colgroup"
                style="background-color: black; color:white"
              >
                Participant Compensation
              </td>
            </tr>
            <tr>
              <td>Get Annual Compensation for EE Contributions</td>
              <td>
                {{ calcData.participant.estimated_annual_wages | currency }}
              </td>
            </tr>
            <tr>
              <td>Calculate Eligibile Compensation</td>
              <td>{{ calcData.compensation.eligible | currency }}</td>
            </tr>
            <tr>
              <td
                colspan="4"
                scope="colgroup"
                style="background-color: black; color:white"
              >
                Participant Pre-Tax Contribution Fields
              </td>
            </tr>
            <tr>
              <td>pre_tax_deferral_ytd_dollars</td>
              <td>
                {{ calcData.pre_tax_contribution.ytd_dollars | currency }}
              </td>
            </tr>
            <tr>
              <td>pre_tax_deferral_percent</td>
              <td>
                {{ calcData.pre_tax_contribution.percent | numeral("0.0") }}%
              </td>
            </tr>
            <tr>
              <td>pre_tax_deferral_dollars</td>
              <td>{{ calcData.pre_tax_contribution.dollars | currency }}</td>
            </tr>
            <tr>
              <td>pre_tax_deferral_dollars_frequency</td>
              <td>{{ calcData.pre_tax_contribution.dollars_frequency }}</td>
            </tr>
            <tr>
              <td>pre_tax_deferral_ytd_catchup_dollars</td>
              <td>
                {{
                  calcData.pre_tax_contribution.ytd_catchup_dollars | currency
                }}
              </td>
            </tr>
            <tr>
              <td>pre_tax_deferral_percent_catchup</td>
              <td>
                {{
                  calcData.pre_tax_contribution.percent_catchup
                    | numeral("0.0")
                }}%
              </td>
            </tr>
            <tr>
              <td>pre_tax_deferral_dollars_catchup</td>
              <td>
                {{ calcData.pre_tax_contribution.dollars_catchup | currency }}
              </td>
            </tr>
            <tr>
              <td>pre_tax_deferral_dollars_catchup_frequency</td>
              <td>
                {{ calcData.pre_tax_contribution.dollars_catchup_frequency }}
              </td>
            </tr>
            <tr>
              <td>ee_chosen_auto_enroll_opt_out_pre_tax</td>
              <td>{{ calcData.pre_tax_contribution.opt_out }}</td>
            </tr>
            <tr>
              <td>ee_chosen_auto_escalate_frequency_type_pre_tax</td>
              <td>{{ calcData.pre_tax_contribution.frequency_type }}</td>
            </tr>
            <tr>
              <td>ee_chosen_auto_escalate_annual_pre_tax_percent</td>
              <td>
                {{
                  calcData.pre_tax_contribution.annual_percent | numeral("0.0")
                }}%
              </td>
            </tr>
            <tr>
              <td>ee_chosen_auto_escalate_maximum_pre_tax_percent</td>
              <td>
                {{
                  calcData.pre_tax_contribution.maximum_percent
                    | numeral("0.0")
                }}%
              </td>
            </tr>
            <tr>
              <td>ee_chosen_auto_escalate_frequency1_pre_tax</td>
              <td>{{ calcData.pre_tax_contribution.frequency1 }}</td>
            </tr>
            <tr>
              <td>ee_chosen_auto_escalate_frequency2_pre_tax</td>
              <td>{{ calcData.pre_tax_contribution.frequency2 }}</td>
            </tr>
            <tr>
              <td
                colspan="4"
                scope="colgroup"
                style="background-color: black; color:white"
              >
                Participant Roth Contribution Fields
              </td>
            </tr>
            <tr>
              <td>roth_deferral_ytd_dollars</td>
              <td>{{ calcData.roth_contribution.ytd_dollars | currency }}</td>
            </tr>
            <tr>
              <td>roth_deferral_percent</td>
              <td>
                {{ calcData.roth_contribution.percent | numeral("0.0") }}%
              </td>
            </tr>
            <tr>
              <td>roth_deferral_dollars</td>
              <td>{{ calcData.roth_contribution.dollars | currency }}</td>
            </tr>
            <tr>
              <td>roth_deferral_dollars_frequency</td>
              <td>{{ calcData.roth_contribution.dollars_frequency }}</td>
            </tr>
            <tr>
              <td>roth_deferral_ytd_catchup_dollars</td>
              <td>
                {{ calcData.roth_contribution.ytd_catchup_dollars | currency }}
              </td>
            </tr>
            <tr>
              <td>roth_deferral_percent_catchup</td>
              <td>
                {{
                  calcData.roth_contribution.percent_catchup | numeral("0.0")
                }}%
              </td>
            </tr>
            <tr>
              <td>roth_deferral_dollars_catchup</td>
              <td>
                {{ calcData.roth_contribution.dollars_catchup | currency }}
              </td>
            </tr>
            <tr>
              <td>roth_deferral_dollars_catchup_frequency</td>
              <td>
                {{ calcData.roth_contribution.dollars_catchup_frequency }}
              </td>
            </tr>
            <tr>
              <td>ee_chosen_auto_enroll_opt_out_roth</td>
              <td>{{ calcData.roth_contribution.opt_out }}</td>
            </tr>
            <tr>
              <td>ee_chosen_auto_escalate_frequency_type_roth</td>
              <td>{{ calcData.roth_contribution.frequency_type }}</td>
            </tr>
            <tr>
              <td>ee_chosen_auto_escalate_annual_roth_percent</td>
              <td>
                {{
                  calcData.roth_contribution.annual_percent | numeral("0.0")
                }}%
              </td>
            </tr>
            <tr>
              <td>ee_chosen_auto_escalate_maximum_roth_percent</td>
              <td>
                {{
                  calcData.roth_contribution.maximum_percent | numeral("0.0")
                }}%
              </td>
            </tr>
            <tr>
              <td>ee_chosen_auto_escalate_frequency1_roth</td>
              <td>{{ calcData.roth_contribution.frequency1 }}</td>
            </tr>
            <tr>
              <td>ee_chosen_auto_escalate_frequency2_roth</td>
              <td>{{ calcData.roth_contribution.frequency2 }}</td>
            </tr>
            <tr>
              <td
                colspan="4"
                scope="colgroup"
                style="background-color: black; color:white"
              >
                Participant Post-Tax Contribution Fields
              </td>
            </tr>
            <tr>
              <td>post_tax_deferral_ytd_dollars</td>
              <td>
                {{ calcData.post_tax_contribution.ytd_dollars | currency }}
              </td>
            </tr>
            <tr>
              <td>post_tax_deferral_percent</td>
              <td>
                {{ calcData.post_tax_contribution.percent | numeral("0.0") }}%
              </td>
            </tr>
            <tr>
              <td>post_tax_deferral_dollars</td>
              <td>{{ calcData.post_tax_contribution.dollars | currency }}</td>
            </tr>
            <tr>
              <td>post_tax_deferral_dollars_frequency</td>
              <td>{{ calcData.post_tax_contribution.dollars_frequency }}</td>
            </tr>
            <tr>
              <td>post_tax_contribution_basis</td>
              <td>
                {{ calcData.ldi_balances.post_tax_contrib_basis | currency }}
              </td>
            </tr>
            <tr>
              <td
                colspan="4"
                scope="colgroup"
                style="background-color: black; color:white"
              >
                Obtain Current Balances
              </td>
            </tr>
            <tr>
              <td>Pre-Tax source</td>
              <td>{{ calcData.participant_balance.pre_tax | currency }}</td>
            </tr>
            <tr>
              <td>Roth Source</td>
              <td>{{ calcData.participant_balance.roth | currency }}</td>
            </tr>
            <tr>
              <td>Post-Tax Source</td>
              <td>{{ calcData.participant_balance.post_tax | currency }}</td>
            </tr>
            <tr>
              <td>Rollover Balance</td>
              <td>{{ calcData.participant_balance.rollover | currency }}</td>
            </tr>
            <tr>
              <td>Employer Match Source</td>
              <td>{{ calcData.participant_balance.er_match | currency }}</td>
            </tr>
            <tr>
              <td>Employer Other Source</td>
              <td>{{ calcData.participant_balance.er_other | currency }}</td>
            </tr>
            <tr>
              <td>NQDC</td>
              <td>{{ calcData.nqdc.balance | currency }}</td>
            </tr>
            <tr>
              <td
                colspan="4"
                scope="colgroup"
                style="background-color: black; color:white"
              >
                Calculate Annuitization Factor
              </td>
            </tr>
            <tr>
              <td>Age at Retirement</td>
              <td>
                {{
                  calcData.annuitization_factor.retirement_age | numeral("0.2")
                }}
              </td>
            </tr>
            <tr>
              <td>Annuitization Factor: Monthly Benefit per $100k at DRD</td>
              <td>
                {{
                  calcData.annuitization_factor.monthly_drd_benefit_100k
                    | currency
                }}
              </td>
            </tr>
            <tr>
              <td>
                Annuitization Factor: Monthly Benefit per $100k at DRD + 1
              </td>
              <td>
                {{
                  calcData.annuitization_factor.monthly_drd1_benefit_100k
                    | currency
                }}
              </td>
            </tr>
            <tr>
              <td>Extrapolated Factor for exact Retirement Age</td>
              <td>
                {{
                  calcData.annuitization_factor.exact_retirement_age | currency
                }}
              </td>
            </tr>
            <tr>
              <td
                colspan="4"
                scope="colgroup"
                style="background-color: black; color:white"
              >
                Obtain DB (Pension) Benefits
              </td>
            </tr>
            <tr>
              <td>sponsor_db_plan_monthly_benefit</td>
              <!--<td>{{calcData.pension.pension | currency}}</td>-->
            </tr>
            <tr>
              <td>other_pension_month</td>
              <td>{{ calcData.nqdc.pension | currency }}</td>
            </tr>
            <tr>
              <td
                colspan="4"
                scope="colgroup"
                style="background-color: black; color:white"
              >
                Obtain Part-Time Retirement Income (for future use)
              </td>
            </tr>
            <tr>
              <td>part_time_income_amount_exists</td>
              <!--<td>{{calcData.participant_part_time_income.amount_exists }}</td>-->
            </tr>
            <tr>
              <td>part_time_income_start_age</td>
              <!--<td>{{calcData.participant_part_time_income.start_age }}</td>-->
            </tr>
            <tr>
              <td>part_time_income_end_age</td>
              <!--<td>{{calcData.participant_part_time_income.end_age }}</td>-->
            </tr>
            <tr>
              <td>part_time_income_amount</td>
              <!--<td>{{calcData.participant_part_time_income.amount | currency }}</td>-->
            </tr>
            <tr>
              <td
                colspan="4"
                scope="colgroup"
                style="background-color: black; color:white"
              >
                Current Paycheck Calculations
              </td>
            </tr>
            <tr>
              <td>Pay Period Compensation</td>
              <td>
                {{
                  calcData.current_paycheck.pay_period_compensation | currency
                }}
              </td>
            </tr>
            <tr>
              <td>Pre-Tax Contributions</td>
              <td>
                {{ calcData.current_paycheck.pre_tax_contribs | currency }}
              </td>
            </tr>
            <tr>
              <td>Taxable Income</td>
              <td>{{ calcData.current_paycheck.taxable_income | currency }}</td>
            </tr>
            <tr>
              <td>Federal Taxes before Pre-Tax</td>
              <td>
                {{
                  calcData.current_paycheck.federal_taxes_before_income
                    | currency
                }}
              </td>
            </tr>
            <tr>
              <td>Federal Taxes after Pre-Tax</td>
              <td>
                {{
                  calcData.current_paycheck.federal_taxes_after_income
                    | currency
                }}
              </td>
            </tr>
            <tr>
              <td>State Taxes before Pre-Tax</td>
              <td>
                {{
                  calcData.current_paycheck.state_taxes_before_pre_tax
                    | currency
                }}
              </td>
            </tr>
            <tr>
              <td>State Taxes after Pre-Tax</td>
              <td>
                {{
                  calcData.current_paycheck.state_taxes_after_pre_tax | currency
                }}
              </td>
            </tr>
            <tr>
              <td>Roth Contributions</td>
              <td>{{ calcData.current_paycheck.roth_contribs | currency }}</td>
            </tr>
            <tr>
              <td>Post-Tax Contributions</td>
              <td>
                {{ calcData.current_paycheck.post_tax_contribs | currency }}
              </td>
            </tr>
            <tr>
              <td>NQ Contributions</td>
              <td>{{ calcData.current_paycheck.nqds_contribs | currency }}</td>
            </tr>
            <tr>
              <td>Current State of Residence</td>
              <td>{{ calcData.current_paycheck.current_residence_state }}</td>
            </tr>
            <tr>
              <td
                colspan="4"
                scope="colgroup"
                style="background-color: black; color:white"
              >
                Lost ER Match Calculations
              </td>
            </tr>
            <tr>
              <td>Lost Match This Year</td>
              <td>
                {{
                  calcData.annual_contribution.lost_match_this_year | currency
                }}
              </td>
            </tr>
            <tr>
              <td>Lost Match Total</td>
              <td>{{ calcData.annual_contribution.lost_match | currency }}</td>
            </tr>
            <tbody v-for="ldi_balance in calcData.ldi_balances.rows">
              <tr>
                <td
                  colspan="2"
                  scope="colgroup"
                  style="background-color: orange;"
                >
                  LDI Rate of Return {{ ldi_balance.nominal_rate }}%
                </td>
              </tr>
              <tr>
                <td style="background-color: black; color:white">
                  Obtain Ending Balances at Desired Retirement Date
                </td>
                <td style="background-color: black; color:white">Data</td>
              </tr>
              <tr>
                <td>Ending Balance at DRD of Pre-Tax source</td>
                <td>{{ ldi_balance.pre_tax_source | currency }}</td>
              </tr>
              <tr>
                <td>Ending Balance at DRD of Roth Source</td>
                <td>{{ ldi_balance.roth_source | currency }}</td>
              </tr>
              <tr>
                <td>Ending Balance at DRD of Post-Tax Source</td>
                <td>{{ ldi_balance.post_tax_source | currency }}</td>
              </tr>
              <tr>
                <td>Ending Balance at DRD of Rollover Balance</td>
                <td>{{ ldi_balance.rollover_source | currency }}</td>
              </tr>
              <tr>
                <td>Ending Balance at DRD of Employer Match Source</td>
                <td>{{ ldi_balance.er_match_source | currency }}</td>
              </tr>
              <tr>
                <td>Ending Balance at DRD of Employer Other Source</td>
                <td>{{ ldi_balance.er_other_source | currency }}</td>
              </tr>
              <tr>
                <td>Ending Balance at DRD of NQDC</td>
                <td>{{ ldi_balance.nqdc | currency }}</td>
              </tr>
              <tr>
                <td style="background-color: black; color:white">
                  Obtain Other DC Balances at Desired Retirement Date
                </td>
                <td style="background-color: black; color:white">Data</td>
              </tr>
              <tr>
                <td>other_pre_tax_balances</td>
                <td>{{ ldi_balance.other_pre_tax | currency }}</td>
              </tr>
              <tr>
                <td>other_roth_balances</td>
                <td>{{ ldi_balance.other_roth | currency }}</td>
              </tr>
              <tr>
                <td>other_post_tax_balances</td>
                <td>{{ ldi_balance.other_post_tax | currency }}</td>
              </tr>
              <tr>
                <td>other_pre_tax_balances_retirement</td>
                <td>{{ ldi_balance.other_pre_tax_retirement | currency }}</td>
              </tr>
              <tr>
                <td>other_roth_balances_retirement</td>
                <td>{{ ldi_balance.other_roth_retirement | currency }}</td>
              </tr>
              <tr>
                <td>other_post_tax_balances_retirement</td>
                <td>{{ ldi_balance.other_post_tax_retirement | currency }}</td>
              </tr>
              <tr>
                <td style="background-color: black; color:white">
                  Compute Monthly Retirement Income Paycheck
                </td>
                <td style="background-color: black; color:white">Data</td>
              </tr>
              <tr>
                <td>Desired Monthly Retirement Income</td>
                <td>
                  {{
                    ldi_balance.monthly_retirement_income.desired_income
                      | currency
                  }}
                </td>
              </tr>
              <tr>
                <td>Social Security</td>
                <td>
                  {{
                    calcData.benefit_retirements.drd
                      | currency({ fractionCount: 0 })
                  }}
                </td>
              </tr>
              <tr>
                <td>Monthly Benefit: DC Plan Pre-Tax Source</td>
                <td>
                  {{
                    ldi_balance.monthly_retirement_income.pre_tax_source
                      | currency
                  }}
                </td>
              </tr>
              <tr>
                <td>Monthly Benefit: DC Plan Roth Source</td>
                <td>
                  {{
                    ldi_balance.monthly_retirement_income.roth_source | currency
                  }}
                </td>
              </tr>
              <tr>
                <td>Monthly Benefit: DC Plan Post-Tax Source NOT taxable</td>
                <td>
                  {{
                    ldi_balance.monthly_retirement_income.post_tax_source
                      | currency
                  }}
                </td>
              </tr>
              <tr>
                <td>Monthly Benefit: DC Plan Post-Tax Source taxable</td>
                <td>
                  {{
                    ldi_balance.monthly_retirement_income.post_taxable_source
                      | currency
                  }}
                </td>
              </tr>
              <tr>
                <td>Monthly Benefit: DC Plan Rollover Source</td>
                <td>
                  {{
                    ldi_balance.monthly_retirement_income.rollover_source
                      | currency
                  }}
                </td>
              </tr>
              <tr>
                <td>Monthly Benefit: DC Plan Employer Match Source</td>
                <td>
                  {{
                    ldi_balance.monthly_retirement_income.er_match_source
                      | currency
                  }}
                </td>
              </tr>
              <tr>
                <td>Monthly Benefit: DC Plan Employer Other Source</td>
                <td>
                  {{
                    ldi_balance.monthly_retirement_income.er_other_source
                      | currency
                  }}
                </td>
              </tr>
              <tr>
                <td>Monthly Benefit: NQDC</td>
                <td>
                  {{ ldi_balance.monthly_retirement_income.nqdc | currency }}
                </td>
              </tr>
              <tr>
                <td>Monthly Benefit: Other Pre-Tax Balances</td>
                <td>
                  {{
                    ldi_balance.monthly_retirement_income.other_pre_tax
                      | currency
                  }}
                </td>
              </tr>
              <tr>
                <td>Monthly Benefit: Other Roth Balances</td>
                <td>
                  {{
                    ldi_balance.monthly_retirement_income.other_roth | currency
                  }}
                </td>
              </tr>
              <tr>
                <td>Monthly Benefit: Other Post-Tax Balances</td>
                <td>
                  {{
                    ldi_balance.monthly_retirement_income.other_post_tax
                      | currency
                  }}
                </td>
              </tr>
              <tr>
                <td>Monthly Benefit: Sponsor DB plan</td>
                <td>
                  {{ ldi_balance.monthly_retirement_income.sponsor | currency }}
                </td>
              </tr>
              <tr>
                <td>Monthly Benefit: Other Pension</td>
                <td>
                  {{
                    ldi_balance.monthly_retirement_income.other_pension
                      | currency
                  }}
                </td>
              </tr>
              <tr>
                <td>Monthly Benefit: Federal Taxes</td>
                <td>
                  {{
                    ldi_balance.monthly_retirement_income.federal_taxes
                      | currency
                  }}
                </td>
              </tr>
              <tr>
                <td>Monthly Benefit: State Taxes</td>
                <td>
                  {{
                    ldi_balance.monthly_retirement_income.state_taxes | currency
                  }}
                </td>
              </tr>
              <tr>
                <td>Actual Monthly Retirement Income</td>
                <td>
                  {{
                    ldi_balance.monthly_retirement_income.actual_income
                      | currency
                  }}
                </td>
              </tr>
              <tr>
                <td>Surplus/(Shortfall)</td>
                <td>
                  {{ ldi_balance.monthly_retirement_income.surplus | currency }}
                </td>
              </tr>
              <tr>
                <td style="background-color: black; color:white">
                  Other Items of Note
                </td>
                <td style="background-color: black; color:white">Data</td>
              </tr>
              <tr>
                <td>Federal Adjusted Gross Income at Retirement</td>
                <td>{{ ldi_balance.federal_retirement_income | currency }}</td>
              </tr>
              <tr>
                <td>Marginal Federal and State Tax Rates</td>
                <td>{{ ldi_balance.marginal_federal | numeral("0.1") }}%</td>
              </tr>
              <tr>
                <td>
                  Additional Monthly After-Tax Contribution required to hit goal
                </td>
                <td>{{ ldi_balance.monthly_after_tax | currency }}</td>
              </tr>
              <tr>
                <td>Lost Match Value at DRD</td>
                <td>{{ calcData.annual_contribution.fv_ldi | currency }}</td>
              </tr>
            </tbody>
          </table>
        </md-content>
      </md-content>
    </div>
  </div>
</template>
<style scoped src="bootstrap/dist/css/bootstrap.min.css"></style>

<script>
import RoeCalcInputFields from "@/components/calculators/InputFields";
import store from "@/store";
import { mapGetters } from "vuex";
import { CALC_OUTPUT_FIELDS, CALC_RESET_STATE } from "@/store/actions.type";
import { INPUT_TYPES } from "@/store/calculatorInputs.type";
import "vue-material/dist/vue-material.css";
import "vue-material/dist/theme/default.css";
export default {
  data() {
    return {
      calcAction: CALC_OUTPUT_FIELDS,
      inputCategories: [
        INPUT_TYPES.PARTICIPANT_BALANCE,
        INPUT_TYPES.PARTICIPANT,
        INPUT_TYPES.PLAN_BASIC_DATA,
        INPUT_TYPES.AUTO_ENROLLMENT,
        INPUT_TYPES.AUTO_INCREASE,
        INPUT_TYPES.EMPLOYEE_CONTRIBUTION,
        INPUT_TYPES.EMPLOYEE_MATCH,
        INPUT_TYPES.EMPLOYEE_OTHER,
        INPUT_TYPES.PRE_TAX_CONTRIBUTION,
        INPUT_TYPES.ROTH_CONTRIBUTION,
        INPUT_TYPES.POST_TAX_CONTRIBUTION,
        INPUT_TYPES.NQDC_CONTRIBUTION,
        INPUT_TYPES.COMPLIANCE_LIMIT
      ]
    };
  },
  components: { RoeCalcInputFields },
  computed: {
    ...mapGetters(["calcData"])
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(CALC_RESET_STATE);
    return next();
  }
};
</script>
